import { cva, type VariantProps } from 'class-variance-authority'
import type { ComponentProps } from 'react'
import { cn } from '../cn'

const badge = cva(
  'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset',
  {
    variants: {
      tone: {
        neutral: 'bg-[var(--ad-surface-muted)] text-[var(--ad-text-muted)] ring-[var(--ad-border)]',
        success: 'bg-[var(--ad-success)]/12 text-[var(--ad-success)] ring-[var(--ad-success)]/30',
        warning: 'bg-[var(--ad-warning)]/15 text-[var(--ad-warning)] ring-[var(--ad-warning)]/35',
        danger: 'bg-[var(--ad-danger)]/12 text-[var(--ad-danger)] ring-[var(--ad-danger)]/30',
        info: 'bg-[var(--ad-primary)]/12 text-[var(--ad-primary)] ring-[var(--ad-primary)]/30',
      },
    },
    defaultVariants: { tone: 'neutral' },
  },
)

export type BadgeProps = ComponentProps<'span'> & VariantProps<typeof badge>

export function Badge({ className, tone, ...props }: BadgeProps) {
  return <span className={cn(badge({ tone }), className)} {...props} />
}
